import Folder from 'owa-mail-store/lib/store/schema/Folder';
import store from 'owa-mail-store/lib/store/Store';
import { action, select } from 'satcheljs/lib/legacy';

export interface UpdateFolderCountsInStoreState {
    folder: Folder;
}

export default action('updateFolderCountsInStore')(
    select<UpdateFolderCountsInStoreState>({
        folder: (unreadCount, totalCount, folderId, isDeltaChange) =>
            store.folders.folderTable.get(folderId),
    })(function updateFolderCountsInStore(
        unreadCount: number,
        totalCount: number,
        folderId: string,
        isDeltaChange: boolean,
        state?: UpdateFolderCountsInStoreState
    ) {
        if (state.folder) {
            if (isDeltaChange) {
                state.folder.UnreadCount += unreadCount;
                state.folder.TotalCount += totalCount;
            } else {
                state.folder.UnreadCount = unreadCount;
                state.folder.TotalCount = totalCount;
            }

            // Do not let counts fall below 0 in the store. This state could happen due to the timing of when
            // folder tree is loaded versus listview.
            state.folder.UnreadCount = Math.max(state.folder.UnreadCount, 0);
            state.folder.TotalCount = Math.max(state.folder.TotalCount, 0);
        }
    })
);
